module.exports = __webpack_public_path__ + "staticcomp/img/cover.261d599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/9/cover.jpg
// module id = ts4u
// module chunks = 39